import React, { FC } from 'react';
import { GenAiIcon } from './GenAiIcon';

interface AskAsperButtonProps {
    disabled?: boolean;
    className?: string;
}

export const AskAsperButton: FC<AskAsperButtonProps> = ({
    disabled = false,
    className = '',
}) => {
    const onClick = () => {};
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={`flex h-8 shrink-0 items-center justify-center gap-2 rounded-md px-2 py-0 text-sm font-semibold leading-[22px] text-white shadow-[0px_2px_0px_0px_rgba(95,73,188,0.1)] transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
            style={{
                background:
                    'linear-gradient(86deg, #F69 -14.96%, var(--Colors-Base-Indigo-4, #826FD0) 50%)',
            }}
        >
            <span className="flex items-center p-0.5">
                <GenAiIcon size={20} className="text-white" />
            </span>
            <span>AskAsper</span>
        </button>
    );
};

export default AskAsperButton;
